import { TranslationsContext } from '@teliaee/telia-translate';
import { Container, Heading, Notice, Separator, Text, Section } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RoamingStore from '../../stores/RoamingStore';
import RoamingPackages from '../packages/RoamingPackages';
interface NonEeaCountryCardProps {
  roamingStore?: RoamingStore;
}

@observer
class NonEeaCountryCard extends React.Component<NonEeaCountryCardProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const translate = this.context.translate;
    const {
      roamingStore: { packageList }
    } = this.props;
    if (!packageList.packages || !packageList.packages.length) {
      return null;
    }
    return (
      <Section backgroundColor="neutral-bg-level-2" isFull>
        <Container>
          <Text className="text-center">
            <Heading element="h2" className="sr-only">
              {this.props.roamingStore.selectedCountry?.name}
            </Heading>
            <Heading element="h3" className="h2">
              {translate('roaming.country.non-eea.packages.header')}
            </Heading>
            <Separator spacing="small" color="invisible" />
            <RoamingPackages />
            <Separator spacing="small" color="invisible" />
            <Notice size="small" align="center">
              {translate('roaming.country.non-eea.notice.text')} <br />
            </Notice>
          </Text>
        </Container>
      </Section>
    );
  }
}

export default inject('roamingStore')(NonEeaCountryCard);
